import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class BusinessProvinceProxy extends ProxyBase {
  getBusinessProvinceTable(params) {
    return this.get('BusinessProvince', params)
  }

  downloadBusinessProvince(params) {
    return this.post('BusinessProvince/Export', params, {}, 'download')
  }
}

export default new BusinessProvinceProxy('IndustryOverview/')
